export interface LinkedChild {
  link_id: string
  child: {
    id: string
    first_name: string | null
    last_name: string | null
    email: string | null
    avatar_url: string | null
  } | null
}

export interface ChildDashboard {
  child: {
    id: string
    first_name: string | null
    last_name: string | null
  }
  last_session: {
    ended_at: string | null
    duration_minutes: number
    course_title: string | null
  } | null
  mastery_percent: number
  streak_days: number
  minutes_this_week: number
  minutes_this_month: number
  recent_badges: { code: string; earned_at: string | null }[]
  objectives: {
    id: string
    title: string
    status: string
    target_date: string | null
  }[]
}

export interface TimeWindow {
  start: string
  end: string
}

/** Les jours sont les clés attendues par l'API, en anglais et en minuscules. */
export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const

export type Weekday = (typeof WEEKDAYS)[number]

export type ToneLevel = 'all' | 'no_informal' | 'formal_only'

/** Durées proposées par les spécifications § 8.3 ; null vaut « illimité ». */
export const SESSION_DURATIONS = [15, 30, 60] as const

export const DAILY_DURATIONS = [30, 60, 120] as const

export interface Restrictions {
  time_windows: Partial<Record<Weekday, TimeWindow[]>>
  max_session_minutes: number | null
  max_daily_minutes: number | null
  tone_level: ToneLevel
  restricted_topics: string[]
  alerts: Record<string, boolean>
  available_topics: string[]
  available_alerts: string[]
}

/** Ce que le formulaire renvoie à l'API : les listes de référence sont en lecture seule. */
export type RestrictionsPayload = Omit<Restrictions, 'available_topics' | 'available_alerts'>
